var Dlrt;
(function (Dlrt) {
    class TagsListFilter {
        constructor(tags) {
            this.tags = tags;
            this.tags.click(e => $(e.currentTarget).toggleClass('active'));
        }
        get View() {
            return this.tags;
        }
        get Values() {
            return $.makeArray(this.tags.filter('.active').find('span').map(function () { return $(this).data('value'); }));
        }
        hasValue() {
            return this.Values.length > 0;
        }
        clear() {
            this.tags.removeClass('active');
        }
    }
    Dlrt.TagsListFilter = TagsListFilter;
})(Dlrt || (Dlrt = {}));
$.fn.makeTagsListFilter = function () {
    return new Dlrt.TagsListFilter(this);
};

//# sourceMappingURL=TagsListFilter.js.map
